import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    minWidth: 320,
    marginTop: theme.spacing(1),
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  }
}));

export const LinkCameraModal = ({ open, onClose, onLinkSuccess }) => {
  const classes = useStyles();
  const [step, setStep] = useState(1); // 1: Input Token, 2: Edit Name
  const [token, setToken] = useState('');
  const [cameraName, setCameraName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    setStep(1);
    setToken('');
    setCameraName('');
    setError('');
    onClose();
  };

  const handleValidateToken = async () => {
    if (!token.trim()) {
      setError('Por favor, ingresa un token válido.');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Mock Cloud Function call for token validation
      // In a real scenario, this would be: 
      // const validateCameraToken = firebase.functions().httpsCallable('validateCameraToken');
      // const result = await validateCameraToken({ token });
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Simulate success or failure
      if (token.toLowerCase() === 'error') {
        throw new Error('Token inválido. Intenta nuevamente.');
      }
      
      const mockedCameraName = `Cámara ${token.substring(0, 4).toUpperCase()}`;
      setCameraName(mockedCameraName);
      setStep(2);
    } catch (err) {
      setError(err.message || 'Error al validar el token.');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveName = () => {
    if (!cameraName.trim()) {
      setError('El nombre de la cámara no puede estar vacío.');
      return;
    }
    
    // Pass the new camera info back to the parent
    onLinkSuccess({
      id: token, // using token as ID for mock
      token: token,
      name: cameraName
    });
    
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        {step === 1 ? 'Enlazar Nueva Cámara' : 'Confirmar Nombre de Cámara'}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {step === 1 ? (
          <>
            <Typography variant="body2" color="textSecondary">
              Ingresa el token proporcionado por tu cámara para enlazarla a tu cuenta.
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              id="token"
              label="Token de la Cámara"
              type="text"
              fullWidth
              variant="outlined"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              disabled={loading}
              error={!!error}
              helperText={error}
            />
          </>
        ) : (
          <>
            <Typography variant="body2" color="textSecondary">
              ¡Token validado! Puedes editar el nombre con el que identificarás esta cámara.
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              id="cameraName"
              label="Nombre de la Cámara"
              type="text"
              fullWidth
              variant="outlined"
              value={cameraName}
              onChange={(e) => setCameraName(e.target.value)}
              disabled={loading}
              error={!!error}
              helperText={error}
            />
          </>
        )}

        {loading && (
          <div className={classes.loader}>
            <CircularProgress size={24} />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" disabled={loading}>
          Cancelar
        </Button>
        {step === 1 ? (
          <Button onClick={handleValidateToken} color="primary" variant="contained" disabled={loading}>
            Validar Token
          </Button>
        ) : (
          <Button onClick={handleSaveName} color="primary" variant="contained" disabled={loading}>
            Guardar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
